module.exports = __webpack_public_path__ + "img/稿定设计-4.861a8429.jpg";